import React from 'react';

const classNameByType = {
  big: 'font-poppins text-5xl font-extrabold text-blue-10',
  medium: 'font-poppins text-2xl font-bold text-blue-10',
  small: 'font-inter text-lg text-gray-10',
  xsmall: 'font-inter text-sm text-gray-10',
};

/**
 *
 * @param {{
 *   type: 'big' | 'medium' | 'small' | 'xsmall',
 *   text?: string,
 *   className?: string,
 *   children: React.ReactNode
 * }} props
 * @returns {JSX.Element}
 */

const Text = ({ type, text, className, children }) => {
  if (text || children)
    return (
      <p className={`${classNameByType[type] || ''} ${className}`}>
        {text && <span dangerouslySetInnerHTML={{ __html: text }} />}
        {children}
      </p>
    );

  return null;
};

export default Text;
